import { Component, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'kt-snow-effect',
  templateUrl: './snow-effect.component.html',
  styleUrls: ['./snow-effect.component.scss']
})
export class SnowEffectComponent implements OnInit, OnDestroy {
  private snowContainer: HTMLElement;
  private intervalId: any;
  public snowflakeCount = 0;
  private maxSnowflakes = 10; // Giảm xuống cực thấp để tránh lag hoàn toàn
  private isPerformanceOptimized = true;
  private isMobile = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.detectMobile();
    if (!this.isMobile) {
      this.initSnowEffect();
    } else {
      console.log('Mobile detected - snow effect disabled for performance');
    }
  }

  private detectMobile(): void {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                   window.innerWidth < 768;
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    // Dọn dẹp tất cả snowflakes khi component bị destroy
    if (this.snowContainer) {
      this.snowContainer.innerHTML = '';
    }
  }

  private initSnowEffect(): void {
    console.log('Initializing snow effect...');
    this.snowContainer = this.el.nativeElement.querySelector('.snow-container');
    
    if (!this.snowContainer) {
      console.error('Snow container not found!');
      return;
    }
    
    console.log('Snow container found, starting continuous snowfall...');
    
    // Tạo tuyết rất chậm để tránh lag hoàn toàn
    this.intervalId = setInterval(() => {
      if (this.snowflakeCount < this.maxSnowflakes) {
        this.createSnowflake();
      }
    }, 1000); // 1 giây tạo 1 bông để tránh lag
  }

  private createSnowflake(): void {
    const snowflake = this.renderer.createElement('div');
    
    // Random properties
    const size = Math.random() * 8 + 4; // 4-12px (larger)
    const startX = Math.random() * window.innerWidth;
    const duration = Math.random() * 4000 + 2000; // 2-6 giây
    
    // Styling tối thiểu để tránh lag nhưng có border xanh để nổi bật
    snowflake.style.position = 'absolute';
    snowflake.style.top = '-10px';
    snowflake.style.left = startX + 'px';
    snowflake.style.width = size + 'px';
    snowflake.style.height = size + 'px';
    snowflake.style.backgroundColor = '#f0f8ff'; // Màu trắng xanh nhạt
    snowflake.style.border = '1px solid #4285f4'; // Viền xanh dương để nổi bật
    snowflake.style.borderRadius = '50%';
    snowflake.style.pointerEvents = 'none';
    snowflake.style.zIndex = '9999';
    snowflake.style.opacity = '0.8'; // Cố định opacity
    
    this.renderer.appendChild(this.snowContainer, snowflake);
    this.snowflakeCount++;
    
    // Random chọn animation để tuyết rơi qua lại
    const animations = ['snowfall-left', 'snowfall-right', 'snowfall-swing', 'snowfall-straight'];
    const randomAnimation = animations[Math.floor(Math.random() * animations.length)];
    
    // Sử dụng CSS animation với drift ngẫu nhiên
    snowflake.style.animation = `${randomAnimation} ${duration}ms linear forwards`;
    
    // Tự động xóa sau khi animation kết thúc
    setTimeout(() => {
      this.removeSnowflake(snowflake);
    }, duration);
  }

  private removeSnowflake(snowflake: HTMLElement): void {
    if (snowflake && snowflake.parentNode) {
      this.renderer.removeChild(this.snowContainer, snowflake);
      this.snowflakeCount--;
    }
  }
}